<template>
  <v-avatar
    :size="size"
    :color="bgrColor"
    :class="{ 'v-list-item__avatar': listItemAvatar }"
    class="p-avatar"
  >
    <span
      v-if="imageError || !email"
      :style="`font-size:${charSize}px`"
      class="white--text"
    >
      {{ char }}
    </span>
    <img
      v-else
      v-bind="$attrs"
      :src="imageUrl"
      alt="avatar image"
      @error="onImageError"
    />
  </v-avatar>
</template>


<script>
import md5 from 'md5'


export default {
  inheritAttrs: false,

  props: {
    email: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 40
    },
    protocol: {
      type: String,
      default: ''
    },
    color: {
      type: String
    },
    char: {
      type: String
    },
    listItemAvatar: {
      type: Boolean,
      default: false
    }
  },


  data () {
    return {
      imageError: false
    }
  },


  computed: {
    charSize () {
      return this.size / 2
    },

    bgrColor () {
      if (this.imageError || !this.email) {
        return this.color ? this.color : '#aaa'
      }
      return undefined
    },

    imageUrl () {
      let protocol = this.protocol || ''
      if (protocol && !protocol.endsWith(':')) {
        protocol += ':'
      }

      const url = [
        `${protocol}//www.gravatar.com/avatar/`,
        md5(this.email.trim().toLowerCase()),
        `?s=${this.size}`,
        '&d=404&r=g'
      ]

      return url.join('')
    }
  },


  methods: {
    onImageError () {
      this.imageError = true
    }
  }
}
</script>
